/**
 * @generated SignedSource<<18d9bce7b120bbde9bb95042d50feb85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAnswerInput = {
  answerId: string;
  clientMutationId?: string | null;
};
export type GridQuestionEditor_deleteColumn_Mutation$variables = {
  input: DeleteAnswerInput;
};
export type GridQuestionEditor_deleteColumn_Mutation$data = {
  readonly deleteAnswer: {
    readonly element: {
      readonly answers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly position: number;
            readonly text: string | null;
          } | null;
        } | null>;
      };
      readonly id: string;
    } | null;
  } | null;
};
export type GridQuestionEditor_deleteColumn_Mutation = {
  response: GridQuestionEditor_deleteColumn_Mutation$data;
  variables: GridQuestionEditor_deleteColumn_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAnswerPayload",
    "kind": "LinkedField",
    "name": "deleteAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ElementNode",
        "kind": "LinkedField",
        "name": "element",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AnswerNodeConnection",
            "kind": "LinkedField",
            "name": "answers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AnswerNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnswerNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "position",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GridQuestionEditor_deleteColumn_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GridQuestionEditor_deleteColumn_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "64e106a5075a7c3ca4a5d6331be242b3",
    "id": null,
    "metadata": {},
    "name": "GridQuestionEditor_deleteColumn_Mutation",
    "operationKind": "mutation",
    "text": "mutation GridQuestionEditor_deleteColumn_Mutation(\n  $input: DeleteAnswerInput!\n) {\n  deleteAnswer(input: $input) {\n    element {\n      id\n      answers {\n        edges {\n          node {\n            id\n            text\n            position\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8012ca5cdd1009e1437e11053a892d63";

export default node;
